import Kunji from "./Kunji";
import L4 from "./L4";
import LC3 from "./LC3";

const LC1 = () => {
  return (
    <div className="">
      <div>
        <Kunji />

        <LC3 />
        <L4 />
      </div>
    </div>
  );
};

export default LC1;
